import ProgramListContainer from './program_list_container';

const ProgramList = ProgramListContainer;
export default ProgramList;
